mutation CreateCustomFieldPerPipeline($customField: CreateCustomFieldInputFieldInput!) {
    createCustomField(input: {customField: $customField}) {
        customField {
            id
            attribute {
                displayName
                displayType
                description
            }
            customFieldStats {
                numOfForms
                numOfPipelines
            }
        }
    }
}
